export default __webpack_public_path__ + "static/media/pdf3.a2a7a699.png";